
// import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "animate.css";
// import { Container, Button } from "react-bootstrap";
// import homeImage from "../assets/home.jpg";
// import WhyGrowCapital from "./WhyGrowCapital";
// import WhyChooseUs from "./WhyChooseUs";
// import ContactUs from "./ContactUs";
// import { useNavigate } from "react-router-dom";
// import LiveTicker from "./LiveTicker";

// const Home = () => {
//   const navigate = useNavigate();

//   const sectionStyle = {
//     backgroundImage: `url(${homeImage})`,
//     backgroundSize: "cover",
//     backgroundPosition: "center",
//     height: "70vh",
//     position: "relative",
//     display: "flex",
//     justifyContent: "center", // center horizontally
//     alignItems: "center", // center vertically
//     color: "white",
//     textAlign: "center",
//     overflow: "hidden",
//   };

//   const overlayStyle = {
//     position: "absolute",
//     inset: 0,
//     background: "rgba(0, 0, 0, 0.35)", // light transparent overlay
//   };

//   const textContainerStyle = {
//     position: "relative",
//     zIndex: 2,
//   };

//   return (
//     <>
//       <section style={sectionStyle}>
//         <div style={overlayStyle}></div>

//         <Container>
//           <div style={textContainerStyle}>
//             {/* Heading Part */}
//             <h1
//               className="animate__animated animate__fadeInDown"
//               style={{
//                 fontSize: "2.5rem",
//                 fontWeight: "600",
//                 color: "#fff",
//                 marginBottom: "10px",
//               }}
//             >
//               Welcome to
//             </h1>

//             <h1
//               className="animate__animated animate__fadeInDown animate__delay-1s"
//               style={{
//                 fontSize: "3.5rem",
//                 fontWeight: "800",
//                 color: "#00cfff",
//                 textShadow: "0 0 15px rgba(0,207,255,0.6)",
//                 marginBottom: "15px",
//               }}
//             >
//               STOCK MARKET INVESTING BY GROW CAPITAL
//             </h1>

//             {/* Subtext */}
//             <p
//               className="animate__animated animate__fadeInUp animate__delay-2s"
//               style={{
//                 fontSize: "1.1rem",
//                 color: "#f1f1f1",
//                 maxWidth: "600px",
//                 margin: "0 auto 25px auto",
//               }}
//             >
//               Your trusted partner in financial growth and investment success.
//             </p>

//             {/* Button */}
//             <Button
//               variant="info"
//               size="lg"
//               className="fw-bold text-white animate__animated animate__fadeInUp animate__delay-3s"
//               style={{
//                 backgroundColor: "#00cfff",
//                 border: "none",
//                 fontSize: "1.2rem",
//                 padding: "12px 30px",
//                 borderRadius: "8px",
//                 boxShadow: "0 0 20px rgba(0,207,255,0.6)",
//                 transition: "all 0.3s ease",
//               }}
//               onMouseEnter={(e) => {
//                 e.target.style.transform = "scale(1.08)";
//                 e.target.style.boxShadow = "0 0 30px rgba(0,207,255,0.8)";
//               }}
//               onMouseLeave={(e) => {
//                 e.target.style.transform = "scale(1)";
//                 e.target.style.boxShadow = "0 0 20px rgba(0,207,255,0.6)";
//               }}
//               onClick={() => navigate("/signup")}
//             >
//               GET STARTED
//             </Button>
//           </div>
//         </Container>
//       </section>

//       <LiveTicker />
//       <WhyGrowCapital />
//       <WhyChooseUs />
//       <ContactUs />
//     </>
//   );
// };

// export default Home;

import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css";
import { Container, Button } from "react-bootstrap";
import homeImage from "../assets/home.jpg";
import WhyGrowCapital from "./WhyGrowCapital";
import WhyChooseUs from "./WhyChooseUs";
import ContactUs from "./ContactUs";
import { useNavigate } from "react-router-dom";
import LiveTicker from "./LiveTicker";

const Home = () => {
  const navigate = useNavigate();

  const sectionStyle = {
    backgroundImage: `url(${homeImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: "70vh", // ⭐ height ki jagah minHeight — content bade hone par section bhi badhega, cut nahi hoga
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
    textAlign: "center",
    padding: "60px 0", // ⭐ upar-neeche breathing space, taaki content edges se na chipke
  };

  const overlayStyle = {
    position: "absolute",
    inset: 0,
    background: "rgba(0, 0, 0, 0.35)",
  };

  const textContainerStyle = {
    position: "relative",
    zIndex: 2,
  };

  return (
    <>
      {/* ⭐ Responsive font-size fallback for very small screens via clamp() below */}
      <style>
        {`
          .hero-welcome-text {
            font-size: clamp(1.5rem, 6vw, 2.5rem);
          }
          .hero-main-heading {
            font-size: clamp(1.8rem, 7vw, 3.5rem);
          }
          .hero-subtext {
            font-size: clamp(0.95rem, 3vw, 1.1rem);
          }
        `}
      </style>

      <section style={sectionStyle}>
        <div style={overlayStyle}></div>

        <Container>
          <div style={textContainerStyle}>
            {/* Heading Part */}
            <h1
              className="animate__animated animate__fadeInDown hero-welcome-text"
              style={{
                fontWeight: "600",
                color: "#fff",
                marginBottom: "10px",
              }}
            >
              Welcome to
            </h1>

            <h1
              className="animate__animated animate__fadeInDown animate__delay-1s hero-main-heading"
              style={{
                fontWeight: "800",
                color: "#00cfff",
                textShadow: "0 0 15px rgba(0,207,255,0.6)",
                marginBottom: "15px",
              }}
            >
              STOCK MARKET INVESTING BY GROW CAPITAL
            </h1>

            {/* Subtext */}
            <p
              className="animate__animated animate__fadeInUp animate__delay-2s hero-subtext"
              style={{
                color: "#f1f1f1",
                maxWidth: "600px",
                margin: "0 auto 25px auto",
              }}
            >
              Your trusted partner in financial growth and investment success.
            </p>

            {/* Button */}
            <Button
              variant="info"
              size="lg"
              className="fw-bold text-white animate__animated animate__fadeInUp animate__delay-3s"
              style={{
                backgroundColor: "#00cfff",
                border: "none",
                fontSize: "1.2rem",
                padding: "12px 30px",
                borderRadius: "8px",
                boxShadow: "0 0 20px rgba(0,207,255,0.6)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "scale(1.08)";
                e.target.style.boxShadow = "0 0 30px rgba(0,207,255,0.8)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "scale(1)";
                e.target.style.boxShadow = "0 0 20px rgba(0,207,255,0.6)";
              }}
              onClick={() => navigate("/signup")}
            >
              GET STARTED
            </Button>
          </div>
        </Container>
      </section>

      <LiveTicker />
      <WhyGrowCapital />
      <WhyChooseUs />
      <ContactUs />
    </>
  );
};

export default Home;